module.exports = __webpack_public_path__ + "static/media/cat.e88db3a5.svg";